/**
 * Public-facing id prefixes per the API guidelines.
 *
 * The architecture plan (.notes/architecture.next-steps.md §"API surface")
 * codifies a single source of truth for the prefix of every resource id
 * the API exposes. Internally, storage may use raw slugs ("authoring"),
 * but on the wire ids are always prefixed ("bizfn_authoring").
 *
 * Helpers below convert between the two: `toPublicId(prefix, slug)`
 * produces `prefix_slug`; `parsePublicId(prefix, public)` validates the
 * prefix and returns the raw slug, throwing `IdParseError` on mismatch.
 */
export const IdPrefix = {
    business_function: 'bizfn',
    derivedContext: 'dctx',
    skill: 'skl',
    engineer: 'eng',
    plan: 'plan',
    project: 'proj',
    roadmap: 'rmap',
    team_change: 'tchg',
    branch: 'branch',
    repo: 'repo',
    org: 'org',
    user: 'usr',
    installation: 'install',
};
export class IdParseError extends Error {
    received;
    expectedPrefix;
    constructor(received, expectedPrefix) {
        super(`id "${received}" does not start with expected prefix "${expectedPrefix}_"`);
        this.received = received;
        this.expectedPrefix = expectedPrefix;
        this.name = 'IdParseError';
    }
}
export function toPublicId(prefix, slug) {
    return `${prefix}_${slug}`;
}
/**
 * Strip the prefix from a public id and return the slug.
 * Throws IdParseError if the prefix is missing or wrong.
 */
export function parsePublicId(prefix, publicId) {
    const lead = `${prefix}_`;
    if (!publicId.startsWith(lead)) {
        throw new IdParseError(publicId, prefix);
    }
    return publicId.slice(lead.length);
}
/**
 * Predicate form of parsePublicId for narrowing.
 */
export function isPublicId(prefix, value) {
    return value.startsWith(`${prefix}_`);
}
//# sourceMappingURL=ids.js.map